import { createContext, useContext } from 'react';

export const DragHandleContext = createContext({});
export const useDragHandle = () => useContext(DragHandleContext);
